import React from 'react'
import '../../styles/nss/main.css';

const Main = () => {
  return (
    <>
        <section className="nss-section">
            <div className="nss-container">
            
            <h1 className="nss-title">राष्ट्रीय सेवा योजना / NATIONAL SERVICE SCHEME (NSS)</h1>

            <div className="nss-card">

                {/* Top Banner Image */}
                {/* <div className="nss-banner">
                <img
                    src="/images/nss-banner.jpg"
                    alt="NSS Banner"
                />
                </div> */}

                {/* About NSS */}
                <div className="nss-content">
                    <h2>About NSS</h2>

                    <p>
                        राष्ट्रीय सेवा योजना (NSS) भारत सरकार के युवा कार्यक्रम एवं खेल मंत्रालय की एक केंद्रीय क्षेत्र योजना है। यह विद्यार्थियों को विभिन्न सरकारी नेतृत्व वाली सामुदायिक सेवा गतिविधियों एवं कार्यक्रमों में भाग लेने का अवसर प्रदान करती है। इसका मुख्य उद्देश्य स्वैच्छिक सामुदायिक सेवा के माध्यम से छात्र-युवाओं के व्यक्तित्व एवं चरित्र का विकास करना है।
                    </p>

                    <p>
                        “स्वयं से पहले आप” (Not Me, But You) के मूल मंत्र के साथ राष्ट्रीय सेवा योजना की शुरुआत 24 सितम्बर 1969 को राष्ट्रपिता महात्मा गांधी की जन्म शताब्दी वर्ष के अवसर पर हुई थी। वास्तव में, एक भारतीय के रूप में राष्ट्र हम सभी के लिए सर्वोपरि है और अपने राष्ट्र की सेवा करना प्रत्येक नागरिक का प्रथम कर्तव्य है।
                    </p>
                    <p>उक्त उद्देश्य की पूर्ति हेतु वर्तमान समय में राष्ट्रीय सेवा योजना विभिन्न राज्यों में युवाओं के सर्वांगीण एवं समावेशी विकास के लिए एक सशक्त मंच प्रदान कर रही है। विद्यालयों एवं विश्वविद्यालयों में रचनात्मक एवं सामाजिक गतिविधियों का आयोजन करके युवाशक्ति को राष्ट्र सेवा हेतु प्रेरित एवं उपयोगी बनाया जा रहा है, ताकि देश के विकास में उनकी सक्रिय भागीदारी सुनिश्चित हो सके।</p>
                </div>

                {/* Image Gallery */}
                <div className="nss-gallery">

                    <div className="gallery-item">
                        <img
                        src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSgrUrbPfcDNgwSm_8Rb9FjfuLrRkKKMx6irg&s"
                        alt="swami vivekanand image"
                        />
                        <p style={{textAlign:"justify"}}>
                            लोगों के जीवन को उन्नतिशील बनाने हेतु जब तुम उन्हें उत्तरदायित्व सौंपते हो, जब तुम उनमें आत्मविश्वास उत्पन्न करते हो, 
                            जिसके अभाव में वे कुछ भी नहीं हैं। जब उनमें आत्मविश्वास उत्पन्न हो जाता है तब वे अति कठिन परिस्थितियों में भी जूझकर 
                            उनका समाधान कर सकते हैं और उनमें यह आत्मविश्वास जागृत करने के लिये आवश्यक है कि तुम्हें उनकी राष्ट्र निर्माण की शक्ति 
                            पर पूरा भरोसा हो। विश्वास से विश्वास उपजता है और प्रजातन्त्र तब पनपता है जब समस्त जन समुदाय विशेष कर समाज के कमजोर 
                            वर्गों के लोग पूरी तरह इस तथ्य को स्वीकार करें। <br/><br/> (-स्वामी विवेकानन्द)
                        </p>
                    </div>

                    <div className="gallery-item">
                        <img
                        src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQEY3WIrpBZIfHZvXxDms0KL6Ia3Rpe2kaRTw&s"
                        alt="sangeeta shukla image"
                        />
                        <p style={{textAlign:"justify"}}>
                            राष्ट्रीय सेवा योजना केवल एक कार्यक्रम नहीं, बल्कि यह जीवन जीने का तरीका है। इसका मूल भाव निज स्वार्थ से ऊपर उठकर समाज की सेवा है। 
                            जब हम दूसरों की भलाई के लिए कार्य करते हैं, तभी असली लोकतंत्र की नींव मजबूत होती है। रा०से०यो० स्वयं सेवकों से अपेक्षा करता है कि वे समाज 
                            के कमजोर वर्गों, ग्रामीण क्षेत्रों और जरूरतमंद लोगों की सहायता करें। समाज का उत्थान केवल सरकार से नहीं होता, बल्कि हर नागरिक के योगदान से 
                            होता है। सच्ची खुशी और संतोष हमें तभी मिलेगा जब हम "मैं" की सीमा से बाहर निकलकर "हम" के दायरे में काम करेंगे, रा०से०यो० का यही संदेश है 
                            "स्वयं को बदलो और समाज को बदलो" । <br/><br/> (-प्रो० संगीता शुक्ला, मा० कुलपति)
                        </p>
                    </div>

                    <div className="gallery-item">
                        <img
                        src="https://cv.ccsuniversity.ac.in/assets/images/CV/Dashboard/uimage/22010300_pic.jpg"
                        alt="dushyant kumar chauhan"
                        />
                        <p style={{textAlign:"justify"}}>
                            राष्ट्रीय सेवा योजना हमें यह सिखाती है कि वास्तविक शक्ति हमारे भीतर के करुणा और त्याग में है। आज के समय में जब हर कोई भौतिक सुख-सुविधाओं के 
                            पीछे भाग रहे हैं तब हमें राष्ट्रीय सेवा योजना याद दिलाती है कि समाज सेवा तथा राष्ट्रीय सेवा सर्वोपरी है। एक स्वयंसेवक का कर्तव्य है कि वह अपने आस-पास 
                            के लोगों की समस्याओं को समझे, समाधान में सहयोग करे और जागरूकता फैलाए। रा०से०यो० केवल सामाजिक कार्य नहीं, बल्कि व्यक्तित्व निर्माण का भी 
                            साधन है। यह हमें जिम्मेदारी, अनुशासन और सहयोग का महत्व सिखाता है। सच्चा स्वयंसेवक वही है जो बिना किसी प्रतिफल की अपेक्षा के, समाज के लिए 
                            निरंतर कार्य करता रहे। यही सेवा असली देशभक्ति है।  <br/><br/> (-डॉ० दुष्यन्त कुमार चौहान, कार्यक्रम समन्वयक, _राष्ट्रीय सेवा योजना)
                        </p>
                    </div>

                </div>

                <table class="nss-table">
                    <thead>
                        <tr>
                        <th>क्रमांक</th>
                        <th>नोटिस</th>
                        <th>दृश्य</th>
                        </tr>
                    </thead>

                    <tbody>
                        <tr>
                        <td>1</td>
                        <td>वित्तीय वर्ष 2026-27 में नयी संस्थाओं में राष्ट्रीय सेवा योजना नवीन इकाईयों के सृजन के सम्बन्ध में</td>
                        <td>
                            <button class="view-btn"><a href='https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2026/06/Registration%20form%20New%20NSS%20Unit.pdf' target="_blank">view</a></button>
                        </td>
                        </tr>  
                    </tbody>
                </table>

                <div className="nss-content" style={{textAlign:"justify"}}>
                    <h2>राष्ट्रीय सेवा योजना की ऐतिहासिक पृष्ठभूमि</h2>

                    <p>
                        स्वतंत्रता प्राप्ति के प्रारम्भ से ही छात्रों को राष्ट्रीय सेवा के प्रति जागरूक करने का प्रयत्न होता रहा है। सन् 1950 में प्रथम शिक्षा आयोग ने विद्यार्थियों को राष्ट्रीय सेवा के लिए भावना के आधार पर प्रवेश के लिए संस्तुति की। इसके साथ ही तत्कालीन प्रधानमंत्री पं० जवाहरलाल नेहरू के सुझाव पर डॉ० सी०डी० देशमुख की अध्यक्षता में एक आयोग बनाया गया जिसका उद्देश्य छात्रों को स्नातक कक्षाओं में प्रवेश से पूर्व राष्ट्रीय सेवा अनिवार्य रूप से करनी थी। प्रो० के०जी० सैउद्दीन जो विभिन्न देशों में युवाओं की राष्ट्रीय सेवा का अध्ययन कर चुके थे, उनका कहना था कि राष्ट्रीय सेवा स्वयंसेवकों के आधार पर प्रारम्भ की जानी चाहिये। इसी प्रकार का सुझाव शिक्षा आयोग के अध्यक्ष डॉ० डी०एस० कोठारी ने भी दिया।
                    </p>
                    <p>
                        अप्रैल, 1967 में विभिन्न राज्यों के शिक्षा मंत्रियों की बैठक में कहा गया कि छात्रों को एन.सी.सी. में (जो कि प्रारम्भ से ही थी) अथवा एक नवीन कार्यक्रम जो राष्ट्रीय सेवा योजना के नाम से बनाया गया था, भाग ले सकते हैं। मेधावी खिलाड़ी इन योजनाओं से मुक्त रहेंगे और यह एक अन्य योजना राष्ट्रीय खेलकूद संगठन में भाग ले सकते हैं ताकि खेलकूद के विकास पर भी समुचित ध्यान दिया जा सके।
                    </p>
                    <p>
                        सितम्बर 1967 में उपकुलपतियों के एक सम्मेलन में प्रस्तावों का स्वागत किया गया एवं सुझाव दिया गया कि उपकुलपतियों की एक विशेष समिति बनाई जाए जो इसके बारे में विस्तार से विचार कर सके। इसके परिणामस्वरूप योजना आयोग द्वारा पांच करोड़ रुपये चतुर्थ पंचवर्षीय योजना में राष्ट्रीय सेवा योजना को अनुदान दिया गया जिससे चयनित विद्यालयों एवं अन्य शिक्षा संस्थानों में प्रयोग के आधार पर उसे प्रारम्भ किया गया।
                    </p>
                    <p>
                        इसके पश्चात् सत्र 69-70 में शिक्षा मंत्रालय द्वारा समस्त स्नातक कक्षाओं में राष्ट्रीय सेवा योजना को प्रारम्भ किया गया। यह संयोग रहा कि वर्ष 1969 जो कि समाजसेवी राष्ट्रपिता महात्मा गांधी का शताब्दी वर्ष भी था जिसमें इस योजना को प्रारम्भ किया गया।
                    </p>
                    <p>
                        योजना के प्रति छात्रों की प्रतिक्रिया बहुत शानदार रही है। सन् 1969 में रा०से०यो० की शुरूआत 40,000 विद्यार्थियों से हुई। यह संख्या प्रतिवर्ष बढ़ती रही एवं वर्तमान में केवल उ०प्र० में 3,40,000 तथा सम्पूर्ण भारत में 32 लाख से अधिक पहुँच गई है।
                    </p>
                    <p>
                        इस समय योजना का विस्तार सभी राज्यों और देश के सभी विश्वविद्यालयों में हो गया है। छात्र-अध्यापक, माता-पिता, अभिभावक, सरकार, विश्वविद्यालयों और कालेजों में काम करने वाले अधिकारी तथा सामान्य नागरिक अब राष्ट्रीय सेवा योजना की आवश्यकता और उसकी उपादेयता में जागरूकता आई है। वे जनता की कठिनाईयों को अच्छी तरह समझने लगे हैं और उनका विश्लेषण करने लगे हैं। इस प्रकार राष्ट्रीय सेवा योजना शिक्षा को समाज की आवश्यकताओं के अनुरूप बनाने में एक ठोस प्रयास है। रा०से०यो० की कुछ इकाईयों ने अपने शानदार कार्य और अनुकरणीय आचरण से मिसाल कायम की है जिससे समाज ने उन्हें आदर दिया है और उनमें अपना विश्वास व्यक्त किया है। अकाल के मुकाबले में युवा (1973) गन्दगी और बीमारी के विरूद्ध युवा (1974-75) वन रोपण और पेड़ लगाने के लिये युवा" (1975) "आर्थिक विकास के लिए युवा" और युवा ग्रामीण पुनर्निर्माण के लिए" (1976-77) और उससे आगे के विषयों के अन्तर्गत सत्र 2003-04 से "स्वच्छता के लिए युवा" विशेष शिविर आयोजित किये गये, जिनका परिणाम समाज और छात्र वर्ग दोनों के लिए लाभदायक सिद्ध हुआ है। विश्वविद्यालय के छात्रों द्वारा की गयी समाज सेवा के अन्तर्गत कई पहलू जैसे गहन उत्थान कार्य के लिये ग्रामों का ग्रहण, चिकित्सा, समाज सर्वेक्षण, चिकित्सा केन्द्रों की स्थापना, जन प्रतिरक्षण कार्यक्रम, स्वास्थ्य रक्षा के संगठित प्रयत्न, समाज के कमजोर वर्ग के लिए प्रौढ़ शिक्षा कार्यक्रम, रक्तदान, अस्पताल जाकर रोगियों की मदद करना, अनाथों और शारीरिक रूप से विकलांग व्यक्तियों को गृहसदस्य बनाना आदि समाविष्ट हो गये हैं। राष्ट्रीय सेवा योजना के स्वयं सेवकों ने आन्ध्र प्रदेश, गुजरात और तमिलनाडु में तूफान पीड़ितों की सहायता करके, पश्चिम बंगाल, उड़ीसा, बिहार, उ०प्र० ०प्र० और दिल्ली में बाढ़ के दौरान महाराष्ट्र, मध्य प्रदेश और राजस्थान में सूखे के दौरान लोगों की सहायता करके प्रशंसनीय कार्य किया है। रा.से.यो. के स्वयं सेवकों को दिसम्बर, 1984 में भोपाल में जो गैस दुर्घटना हो गयी थी, उस दौरान गैस पीड़ितों को राहत पहुँचाने में सक्रिय भूमिका अदा की। रा.से.यो. के छात्रों ने सामाजिक बुराईयों के उन्मूलन में और राष्ट्रीय स्तर पर मान्य लक्ष्यों जैसे भारतीयता में गर्व महसूस करना, स्वतंत्रता, समाजवाद, धर्म-निरपेक्षता, राष्ट्रीय एकता और वैज्ञानिक दृष्टिकोण के विकास के अभियान में भी उपयोगी कार्य किया है।
                    </p>
                </div>

                {/* Additional Section */}
                {/* <div className="nss-info">
                <h2>NSS Objectives</h2>

                <ul>
                    <li>Develop leadership qualities among students</li>
                    <li>Promote social responsibility and discipline</li>
                    <li>Encourage community participation</li>
                    <li>Create awareness about social issues</li>
                    <li>Build a spirit of national service</li>
                </ul>
                </div> */}

                <div className="nss-content" style={{textAlign:"justify"}}>
                    <h2>रा०से०यो० स्वयं-सेवक</h2>

                    <p>
                    जिस किसी भी छात्र का नाम रा०से०यो० स्वयं सेवक के रूप में लिखा गया हो उसे एक वर्ष में न्यूनतम 120 घंटे के लिए समाज कार्य में रखने के हिसाब से निरन्तर दो वर्ष की अवधि के लिए अर्थात 240 घंटे के लिए कार्य करना होता है तथा विशेष शिविर सात दिवसीय होता है। उसे रा.से.यो. के कार्यक्रमों में पूरी तरह भाग लेना चाहिए और रा०से०यो० के उद्देश्यों से अच्छी तरह परिचित हो जाना चाहिए। छात्र से एक वर्ष के दौरान जो 120 घंटों के लिए सेवा करने की आशा की जाती है उसमें से प्रथम वर्ष में वह न्यूनतम 20 घंटे तो स्थापन पूर्व अभिविन्यास कार्यक्रम के लिए
                    निम्नलिखित रूप से लगाएँ -
                    <ol>
                        <li>सामान्य अभिविन्यास - 2 घंटे</li>
                        <li>विशेष अभिविन्यास - 8 घंटे</li>
                        <li>कार्यक्रम के कौशल को सीखना - 10 से 20 घंटे</li>
                    </ol>
                    </p>
                    
                </div>

                <div className="nss-content" style={{textAlign:"justify"}}>
                    <h2>रा०से०यो० स्वयं-सेवक के कर्त्तव्य</h2>
                    <ol>
                        <li>परियोजना क्षेत्र में व्यक्तियों के साथ सम्पर्क स्थापित करें।</li>
                        <li>समाज की आवश्यकताओं, करिनाईयों और उपलब्ध साधनों का पता लगाएँ।</li>
                        <li>कार्यक्रमों की योजना बनाना और उन्हें कार्यान्वित करना।</li>
                        <li>जिन समस्याओं का पता लग जाए उनके समाधान खोजने की दिशा में अपने ज्ञान और अनुभव को लगाना।</li>
                        <li>अपनी डायरी में क्रियाकलापों को व्यवस्थित रूप से दर्ज करना और प्रगति का आवधिक रूप से आंकलन करना और जिस तरह के परिवर्तन करने की आवश्यकता हो, उन्हें प्रभावी बनाना।</li>
                    </ol>
                </div>

                <div className="nss-content" style={{textAlign:"justify"}}>
                    <h2>सिद्धान्त वाक्य</h2>
                    <p>
                        राष्ट्रीय सेवा योजना का सिद्धान्त वाक्य अथवा प्रत्यवचन है मुझको नहीं तुमको। यह सिद्धान्त वाक्य प्रजातांत्रिक ढंग से रहने का सार बताता है, निःस्वार्थ सेवा की आवश्यकता का समर्थन करता है। यह बताता है कि हम दूसरे व्यक्ति के दृष्टिकोण की सराहना करने वाले बनें तथा सजातीय मनुष्यों के लिए सहानुभूति रखें। यह घोषणा करता है कि व्यक्ति का कल्याण अन्तिम रूप से सम्पूर्ण समाज का कल्याण होने पर ही निर्भर करता है इसलिए रा. से.यो. प्रतिनिधि का लक्ष्य यह होना चाहिए कि इस सिद्वान्त वाक्य का प्रदर्शन वे अपने दैनिक कार्यक्रम में करें।
                    </p>
                    <p>
                        समाज को आपसे नहीं, आपकी दौलत से प्यार है। दौलत वह नहीं जो आपने अर्जित की है बल्कि वह जिसके द्वारा अर्जित की है। वह आपके अन्तःकरण में ही निहित है। जिसे लोग बौद्धिक क्षमता के नाम से जानते हैं।
                    </p>
                </div>

                <div className="nss-content" style={{textAlign:"justify"}}>
                    <h2>राष्ट्रीय सेवा योजना का प्रतीक चिह्न</h2>
                    <p>
                        राष्ट्रीय सेवा योजना का प्रतीक चिह्न उड़ीसा के कोणार्क सूर्य मन्दिर के रथ चक्र पर आधारित है। सूर्य मन्दिर के ये विशाल चक्र सृजन, संरक्षण और निर्मुक्ति के आवर्तन को अभिव्यक्त करते हैं तथा काल और स्थान से परे जीवन में गति का महत्व बताते हैं। प्रतीक का अभिकल्प सूर्य रथ के चक्र का सरलीकृत रूप है, मुख्यतः गति को दर्शाता है। चक्र जीवन के प्रगतिशील चक्र को व्यक्त करता है। यह निरन्तरता का और साथ ही परिवर्तन का भी प्रतीक है और रा.से.यो. को समाज में परिवर्तन लाने और उसे उन्नत करने के लिए निरन्तर आगे बढ़ने के लिए प्रयास करने का द्योतक है।
                    </p>
                    <ul>
                        <li>सफलताओं का श्रेय उदारतापूर्वक दूसरों को देते हुए अपने उत्तरदायित्वों का वहन करो।</li>
                        <li>अपने प्रयासों एवं कार्यों के परिणाम की धैर्य से प्रतीक्षा करो।</li>
                        <li>कड़ी मेहनत ही सफलता की कुँजी है।</li>
                        <li>परिवार के प्रत्येक सदस्य की क्षमताओं का उपयोग तदानुसार करो, वे सब ही तुम्हारी शक्ति के स्रोत हैं।</li>
                        <li>आप जहाँ भी जायेंगे हर जगह आपको ना मिलेगी, हर ना को हाँ में बदलना ही आपकी योग्यता का प्रमाण है।</li>
                    </ul>
                </div>

                <div className="nss-content" style={{textAlign:"justify"}}>
                    <h2>राष्ट्रीय सेवा योजना का बैज</h2>
                    <p>
                        रा.से.यो. का प्रतीक चिह्न रा.से.यो. के बैज पर उत्कीर्ण है। रा.से.यो. के स्वयंसेवक समाज की सेवा के विभिन्न कार्यक्रमों में भाग लेते हुए इसे लगाते हैं। कोणार्क के सूर्य मन्दिर के रथ में 24 पहिये हैं जो सम्पूर्ण दिन के 24 घण्टों का प्रतिनिधित्व करते हैं। प्रत्येक पहिये में 8 तीलियाँ हैं जो 8 पहर दर्शाते हैं। इसलिए जो व्यक्ति इस बैज को धारण करता है उसे यह बैज याद दिलाता है कि वह राष्ट्र सेवा के लिए दिन-रात अर्थात् 24 घंटे (आठों प्रहर) तत्पर रहे। बैज में जो लाल रंग है वह इस बात का संकेत करता है कि रा.से.यो. के स्वयंसेवकों में पूरा उत्साह है और वे जीवंत है, सक्रिय हैं और उनमें स्फूर्ति है। गहरा नीला रंग उस ब्रह्मांड की ओर संकेत करता है जिसका रा.से.यो एक छोटा सा अंश है और जो मानव मात्र का कल्याण करने के लिए अपना अंशदान करने को तैयार है।
                    </p>
                    <p>
                        साधारण स्तर के जीवन यापन के लिए प्रातः 10-00 से सायं 6-00 बजे तक कार्य करना आपकी आवश्यकताओं के लिए संतोषजनक है किन्तु जीवन में यदि कुछ कर दिखाना चाहते हैं तो प्रातः 6 से रात्रि 10 बजे तक कार्य करना सीखो।
                    </p>
                </div>

                <div className="nss-content" style={{textAlign:"justify"}}>
                    <h2>रा०से०यो० के लक्ष्य एवं उद्देश्य</h2>
                    <h3>राष्ट्रीय सेवा योजना का लक्ष्य</h3>
                    <p>
                        समाज सेवा के माध्यम से विद्यार्थियों के व्यक्तित्व का विकास
                    </p>
                    <h3>राष्ट्रीय सेवा योजना के उद्देश्य</h3>
                    <ol>
                        <li>लोगों के साथ मिलकर कार्य करना।</li>
                        <li>स्वयं को सृजनात्मक और रचनात्मक सामाजिक कार्यों में प्रवृत्त करना।</li>
                        <li>स्वयं तथा समुदाय की ज्ञान वृद्धि करना।</li>
                        <li>समस्याओं को कुछ न कुछ हल करने में स्वयं की प्रतिभा का व्यावहारिक उपयोग करना।</li>
                        <li>प्रजातांत्रिक नेतृत्व को क्रियान्वित करने में दक्षता प्राप्त करना।</li>
                        <li>स्वयं को रोजगार के योग्य बनाने के लिए कार्यक्रम विकास में दक्षता प्राप्त करना।</li>
                        <li>शिक्षित और अशिक्षितों के बीच की दूरी मिटाना।</li>
                        <li>समुदाय के कमजोर वर्ग की सेवा के लिए स्वयं में इच्छाएँ जागृत करना।</li>
                    </ol>
                    <ul>
                        <li>समस्याओं के समाधान हेतु मध्य मार्ग अपनाना, सदैव हितकर होता है।</li>
                        <li>व्यक्ति की क्षमता का आंकलन करने के बाद ही उसको त्द्नुसार जिम्मेदारियाँ सौंपनी चाहिए। यदि व्यक्ति असफल होता है तो इसे अपनी असफलता मानो।</li>
                        <li>नेतृत्व करो किसी के नेतृत्व में स्वंय सेवक बनी-स्वंय सेवक बनाओ।</li>
                        <li>अपने लिए छाँव रखो, दूसरों को छाँव दो।</li>
                    </ul>
                </div>

                <div className="nss-content" style={{textAlign:"justify"}}>
                    <h2>लक्ष्य गीत</h2>
                    <div>
                        <span>उठें समाज के लिए, उठे, उठें-2,</span><br/>
                        <span>जगें स्वराष्ट्र के लिये, जगें, जगें</span><br/>
                        <span><b>स्वयं सजें, वसुन्धरा संवार दें-2</b></span><br/>
                        <span>हम उठें, उठेगा जग, हमारे संग साथियों,</span><br/>
                        <span>हम बढ़े, तो सब बढ़ेंगे, अपने आप साथियों,</span><br/>
                        <span>जमीं पे आसमान को उतार दें-2</span><br/>
                        <span><b>स्वयं सजें, वसुन्धरा संवार दें, उठें....</b></span><br/>
                        <span>उदासियों को दूर कर, खुशी को बाँटते चले</span><br/>
                        <span>गांव और शहर की दूरियों को पाटते चलें</span><br/>
                        <span>ज्ञान को प्रचार दें, प्रसार दें</span><br/>
                        <span>विज्ञान को प्रचार दें, प्रसार दें।</span><br/>
                        <span><b>स्वयं सजें, वसुन्धरा संवार दें, उठें.....</b></span><br/>
                        <span>समर्थ बाल वृद्ध और नारियाँ रहे सदा</span><br/>
                        <span>हरे भरे वनों की शाल ओढ़ती रहे धरा</span><br/>
                        <span>तरक्कियों की एक नई कतार दें</span><br/>
                        <span><b>स्वयं सजें, वसुन्धरा संवार दें, उठें....</b></span><br/>
                        <span>ये जाति-धर्म-बोलियाँ, बनें न शूल राह की,</span><br/>
                        <span>बढ़ायें बेल प्रेम की, अखण्डता की चाह की,</span><br/>
                        <span>भावना से यह चमन निखार दें, </span><br/>
                        <span>सद्भावना से यह चमन् निखार दें।</span><br/>
                        <span><b>स्वयं सजें, वसुन्धरा संवार दें, उठें.....</b></span><br/>
                        <span>उठें समाज के लिए, उठें,उठे-2</span><br/>
                        <span>जगे स्वराष्ट्र के लिये, जगें, जगें</span><br/>
                        <span><b>स्वयं सजें, वसुन्धरा संवार दें-2</b></span>
                    </div>
                </div>

                <div className="nss-content" style={{textAlign:"justify"}}>
                    <h2>विशेष शिविर</h2>
                    <p>
                        रा.से.यो. के विशेष शिविर में शिविर अनुभव भी अपना एक विशेष महत्व रखता है। जो विश्वविद्यालय स्तर पर ग्रीष्मावकाश और शीतावकाश में ग्रामीण क्षेत्रों/शहरी गन्दी बस्तियों/हरिजन बस्तियों में 10 दिन की अवधि का होता है। साधारणतया शिविर में 40-50 छात्र-छात्राएं होते हैं। उच्च स्तरीय इण्टर कालेजों एवं राज्य स्तरीय शिविरों का भी समय-समय पर आयोजन किया जाता है।
                    </p>
                    <p>
                        शिविर में भाग लेने वाले प्रतिभागी शिविर जीवन का आनन्द लेते हैं, एक अच्छे नागरिक के कर्तव्य अनुभव करते हैं एवं समाज के लिए क्या सेवा कर सकते हैं, इसका ज्ञान प्राप्त करते हैं।
                    </p>
                    <span><b>"मैं नहीं तू"</b></span>
                    <p>स्वर्ग और नर्क की, चिन्ता को छोड़कर अपने स्व और अहम् को भूलकर केवल तुझे याद कर धर्म सम्प्रदाय की विधाओं को छोड़कर अशिक्षा, दरिद्रता, शोषण को दूर पीड़ित मानवता की सेवा में, बुद्ध की भांति, जीवन उत्सर्ग हेतु प्रयाण है- नव प्रभात को, आदि है यह- अन्त है अन्त तक ।</p>
                </div>

                <table class="nss-table">
                    <thead>
                        <tr>
                        <th>क्रमांक</th>
                        <th>उत्सव विवरण</th>
                        <th>तिथि एवं माह</th>
                        </tr>
                    </thead>

                    <tbody>
                        <tr>
                        <td>1</td>
                        <td>राष्ट्रीय युवा दिवस</td>
                        <td>12 जनवरी</td>
                        </tr>

                        <tr>
                        <td>2</td>
                        <td>राष्ट्रीय युवा सप्ताह</td>
                        <td>12 से 19 जनवरी</td>
                        </tr>

                        <tr>
                        <td>3</td>
                        <td>राष्ट्रीय सेवा योजना दिवस</td>
                        <td>24 सितम्बर</td>
                        </tr>

                        <tr>
                        <td>4</td>
                        <td>गणतंत्र दिवस</td>
                        <td>26 जनवरी</td>
                        </tr>

                        <tr>
                        <td>5</td>
                        <td>महिला दिवस</td>
                        <td>8 मार्च</td>
                        </tr>

                        <tr>
                        <td>6</td>
                        <td>विश्व वन दिवस</td>
                        <td>21 मार्च</td>
                        </tr>

                        <tr>
                        <td>7</td>
                        <td>विश्व स्वास्थ्य दिवस</td>
                        <td>7 अप्रैल</td>
                        </tr>

                        <tr>
                        <td>8</td>
                        <td>जलियां वाला बाग हत्याकांड दिवस</td>
                        <td>13 अप्रैल</td>
                        </tr>

                        <tr>
                        <td>9</td>
                        <td>अग्नि शमन दिवस</td>
                        <td>14 अप्रैल</td>
                        </tr>

                        <tr>
                        <td>10</td>
                        <td>पृथ्वी दिवस</td>
                        <td>22 अप्रैल</td>
                        </tr>

                        <tr>
                        <td>11</td>
                        <td>विश्व मजदूर दिवस</td>
                        <td>1 मई</td>
                        </tr>

                        <tr>
                        <td>12</td>
                        <td>मई दिवस</td>
                        <td>1 मई</td>
                        </tr>

                        <tr>
                        <td>13</td>
                        <td>पोषक खाद्य सप्ताह</td>
                        <td>1 मई से 7 मई</td>
                        </tr>

                        <tr>
                        <td>14</td>
                        <td>विश्व पर्यावरण दिवस</td>
                        <td>5 जून</td>
                        </tr>

                        <tr>
                        <td>15</td>
                        <td>विश्व योग दिवस</td>
                        <td>21 जून</td>
                        </tr>

                        <tr>
                        <td>16</td>
                        <td>स्वच्छ भारत दिवस</td>
                        <td>2 अक्टूबर</td>
                        </tr>

                        <tr>
                        <td>17</td>
                        <td>वन महोत्सव सप्ताह</td>
                        <td>1 जुलाई से 7 जुलाई</td>
                        </tr>

                        <tr>
                        <td>18</td>
                        <td>परमाणु शस्त्र निरोधक आंदोलन</td>
                        <td>6 अगस्त</td>
                        </tr>

                        <tr>
                        <td>19</td>
                        <td>स्वतंत्रता दिवस</td>
                        <td>15 अगस्त</td>
                        </tr>

                        <tr>
                        <td>20</td>
                        <td>सद्भावना दिवस</td>
                        <td>20 अगस्त</td>
                        </tr>

                        <tr>
                        <td>21</td>
                        <td>शिक्षक दिवस</td>
                        <td>5 सितम्बर</td>
                        </tr>

                        <tr>
                        <td>22</td>
                        <td>अन्तर्राष्ट्रीय साक्षरता दिवस/सप्ताह</td>
                        <td>8 से 14 सितम्बर</td>
                        </tr>

                        <tr>
                        <td>23</td>
                        <td>गांधी जयंती</td>
                        <td>2 अक्टूबर</td>
                        </tr>

                        <tr>
                        <td>24</td>
                        <td>विश्व खाद्य दिवस</td>
                        <td>16 अक्टूबर</td>
                        </tr>

                        <tr>
                        <td>25</td>
                        <td>संयुक्त राष्ट्र खाद्य दिवस</td>
                        <td>24 अक्टूबर</td>
                        </tr>

                        <tr>
                        <td>26</td>
                        <td>यातायात नियंत्रण सप्ताह</td>
                        <td>24 से 30 अक्टूबर</td>
                        </tr>

                        <tr>
                        <td>27</td>
                        <td>बचत दिवस</td>
                        <td>31 अक्टूबर</td>
                        </tr>

                        <tr>
                        <td>28</td>
                        <td>राष्ट्रीय एकता दिवस</td>
                        <td>31 अक्टूबर</td>
                        </tr>

                        <tr>
                        <td>29</td>
                        <td>बाल दिवस</td>
                        <td>14 नवम्बर</td>
                        </tr>

                        <tr>
                        <td>30</td>
                        <td>मातृ दिवस</td>
                        <td>19 नवम्बर</td>
                        </tr>

                        <tr>
                        <td>31</td>
                        <td>कौमी एकता सप्ताह</td>
                        <td>19 नव. - 25 नव.</td>
                        </tr>

                        <tr>
                        <td>32</td>
                        <td>पर्यावरण चेतना माह</td>
                        <td>19 नव से 18 दिसम्बर</td>
                        </tr>

                        <tr>
                        <td>33</td>
                        <td>निर्बल वर्ग दिवस</td>
                        <td>22 नवम्बर</td>
                        </tr>

                        <tr>
                        <td>34</td>
                        <td>अन्तर्राष्ट्रीय स्वयंसेवक दिवस</td>
                        <td>5 दिसम्बर</td>
                        </tr>

                        <tr>
                        <td>35</td>
                        <td>मानवाधिकार दिवस</td>
                        <td>10 दिसम्बर</td>
                        </tr>

                        <tr>
                        <td>36</td>
                        <td>विश्व एड्स दिवस</td>
                        <td>1 दिसम्बर</td>
                        </tr>
                    </tbody>
                </table>

            </div>
            </div>
                   
        </section>
    </>
  )
}

export default Main;